// Moves social sharing plugin badge to top right of first image in content block.

jQuery(document).ready(function($) {
	const container = $('.heateor_sss_sharing_container');
	if (container.length) {
		const image = $('.wp-block-image, .story-masthead').first();
		if (image) {
			container.detach;
			image.append(container);
			container.css({opacity: 1});
			container.find('.heateor_sss_sharing_title').css({fontWeight: 400});
		}
	}
}) 